module.exports = __webpack_public_path__ + "img/new4.d0e1837a.png";